 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER101INCURRINGDISASTERTOTHEUPPERBODY from '@/components/0_chapter101incurringdisastertotheupperbody'
 import A_CHAPTER102BLAMEYOURWIFE from '@/components/1_chapter102blameyourwife'
 import A_CHAPTER103SHOCK from '@/components/2_chapter103shock'
 import A_CHAPTER104AMEANOLDLADYOFTHEZHOUFAMILY from '@/components/3_chapter104ameanoldladyofthezhoufamily'
 import A_CHAPTER105HOUSEBURN from '@/components/4_chapter105houseburn'
 import A_CHAPTER106SACRIFICESONINLAWTOPRESERVETHEFAMILY from '@/components/5_chapter106sacrificesoninlawtopreservethefamily'
 import A_CHAPTER107DIVORCEWHENYOUGETBACK from '@/components/6_chapter107divorcewhenyougetback'
 import A_CHAPTER108LOWTHREELOWFOUR from '@/components/7_chapter108lowthreelowfour'
 import A_CHAPTER109CONSPIRACY from '@/components/8_chapter109conspiracy'
 import A_CHAPTER110INVESTATLEAST500MILLION from '@/components/9_chapter110investatleast500million'
 import A0_CHAPTER111MAKEAFOOLOFHIMSELFINPUBLIC from '@/components/10_chapter111makeafoolofhimselfinpublic'
 import A1_CHAPTER112HISABILITYTOTURNBLACKINTOWHITEISTRULYAMAZING from '@/components/11_chapter112hisabilitytoturnblackintowhiteistrulyamazing'
 import A2_CHAPTER113YOUAREWORSETHANANANT from '@/components/12_chapter113youareworsethananant'
 import A3_CHAPTER114ANCESTRALFORBIDDENTECHNIQUE from '@/components/13_chapter114ancestralforbiddentechnique'
 import A4_CHAPTER115KOWTOWAPOLOGIZE from '@/components/14_chapter115kowtowapologize'
 import A5_CHAPTER116THISISCALLEDGETTINGWHATYOUWANT from '@/components/15_chapter116thisiscalledgettingwhatyouwant'
 import A6_CHAPTER117REASONISNONSENSEBEFOREBENEFIT from '@/components/16_chapter117reasonisnonsensebeforebenefit'
 import A7_CHAPTER118GREETINGOFTHEWEALTHIEST from '@/components/17_chapter118greetingofthewealthiest'
 import A8_CHAPTER119DUEPUNISHMENT from '@/components/18_chapter119duepunishment'
 import A9_CHAPTER120TOTHEDEITYSLAKE from '@/components/19_chapter120tothedeityslake'
 import A0_CHAPTER121SPIRITPONDANDDRAGONSHADOW from '@/components/20_chapter121spiritpondanddragonshadow'
 import A1_CHAPTER122UNINTELLIGIBLESCENE from '@/components/21_chapter122unintelligiblescene'
 import A2_CHAPTER123SHEISADRAGON from '@/components/22_chapter123sheisadragon'
 import A3_CHAPTER124ANEGGBESPAWNINTENYEAR from '@/components/23_chapter124aneggbespawnintenyear'
 import A4_CHAPTER125WHATKINDOFWOMANWOULDENCOUNTERSUCHATHING from '@/components/24_chapter125whatkindofwomanwouldencountersuchathing'
 import A5_CHAPTER126DECIDETOSEPARATEFROMHIM from '@/components/25_chapter126decidetoseparatefromhim'
 import A6_CHAPTER127IVECOMETOASKYOUFORSOMETHING from '@/components/26_chapter127ivecometoaskyouforsomething'
 import A7_CHAPTER128IMTHEBESTATTHREATENINGPEOPLE from '@/components/27_chapter128imthebestatthreateningpeople'
 import A8_CHAPTER129NOMATTERHOWLUDICROUSTHEYWERETHEYSTILLHADTOGIVEITATRY from '@/components/28_chapter129nomatterhowludicroustheyweretheystillhadtogiveitatry'
 import A9_CHAPTER130PLEASEGIVEMETHEPOWEROFREVENGE from '@/components/29_chapter130pleasegivemethepowerofrevenge'
 import A0_CHAPTER131ANANGRYGIRL from '@/components/30_chapter131anangrygirl'
 import A1_CHAPTER132THEGREATMASTERISHERE from '@/components/31_chapter132thegreatmasterishere'
 import A2_CHAPTER133DISRESPECTTOTHEMASTER from '@/components/32_chapter133disrespecttothemaster'
 import A3_CHAPTER134LIKEABIGTOAD from '@/components/33_chapter134likeabigtoad'
 import A4_CHAPTER135THEORIGINALPRICEWAS18000YUANBUTNOWITS3000YUAN from '@/components/34_chapter135theoriginalpricewas18000yuanbutnowits3000yuan'
 import A5_CHAPTER136ICANPLAYWITHYOUALLDAY from '@/components/35_chapter136icanplaywithyouallday'
 import A6_CHAPTER137GOURD from '@/components/36_chapter137gourd'
 import A7_CHAPTER138NOMONEYNOFACE from '@/components/37_chapter138nomoneynoface'
 import A8_CHAPTER139TAKEAPISSANDTAKEYOUROWNREFLECTION from '@/components/38_chapter139takeapissandtakeyourownreflection'
 import A9_CHAPTER140LUCKISALWAYSGOOD from '@/components/39_chapter140luckisalwaysgood'
 import A0_CHAPTER141YOUDONTKNOWHOWTOTALKYOUDONTKNOWWHATYOURETALKINGABOUTYOUPRETENDYOUDONTKNOWWHATYOURETALKINGABOUT from '@/components/40_chapter141youdontknowhowtotalkyoudontknowwhatyouretalkingaboutyoupretendyoudontknowwhatyouretalkingabout'
 import A1_CHAPTER142THELASTTHINGINEEDISMONEY from '@/components/41_chapter142thelastthingineedismoney'
 import A2_CHAPTER143ICEKNIFEFORRELIEVINGFISH from '@/components/42_chapter143iceknifeforrelievingfish'
 import A3_CHAPTER144ALLTHREEMILLIONISYOURS from '@/components/43_chapter144allthreemillionisyours'
 import A4_CHAPTER145HEISGOINGTORENEGEONTHEDEBT from '@/components/44_chapter145heisgoingtorenegeonthedebt'
 import A5_CHAPTER146HYPEREMESIS from '@/components/45_chapter146hyperemesis'
 import A6_CHAPTER147YOUDBETTERNOTPLAYTHEHERO from '@/components/46_chapter147youdbetternotplaythehero'
 import A7_CHAPTER148ASTRANGEBLACKOUT from '@/components/47_chapter148astrangeblackout'
 import A8_CHAPTER149AFIANCEE from '@/components/48_chapter149afiancee'
 import A9_CHAPTER150THEPOWEROFTHEBLACKAPOSTLECONTRACT from '@/components/49_chapter150thepoweroftheblackapostlecontract'
 import A0_CHAPTER151HALFOFHISLIFEISLEFT from '@/components/50_chapter151halfofhislifeisleft'
 import A1_CHAPTER152HEISAVERYLONELYMAN from '@/components/51_chapter152heisaverylonelyman'
 import A2_CHAPTER153HECOULDBECALLEDATYRANTORATYRANT from '@/components/52_chapter153hecouldbecalledatyrantoratyrant'
 import A3_CHAPTER154IWILLBLAMEALLOFYOU from '@/components/53_chapter154iwillblameallofyou'
 import A4_CHAPTER155PEOPLEFROMTHEJINFAMILYCAMETOVISIT from '@/components/54_chapter155peoplefromthejinfamilycametovisit'
 import A5_CHAPTER156THEQINFAMILYSRICHANDUSELESSSONINLAW from '@/components/55_chapter156theqinfamilysrichanduselesssoninlaw'
 import A6_CHAPTER157TAKECHARGEOFTHEHOUSEINSTEADOFTHEWIFE from '@/components/56_chapter157takechargeofthehouseinsteadofthewife'
 import A7_CHAPTER158IMGONNABEYOURWIFEINTHENEXTLIFE from '@/components/57_chapter158imgonnabeyourwifeinthenextlife'
 import A8_CHAPTER159HIDDENCARD from '@/components/58_chapter159hiddencard'
 import A9_CHAPTER160RENEGOTIATION from '@/components/59_chapter160renegotiation'
 import A0_CHAPTER161MAKEABETONYOURSONSFUTURE from '@/components/60_chapter161makeabetonyoursonsfuture'
 import A1_CHAPTER162FROMTHENONHEWOULDNEVERBEABLETORECOVER from '@/components/61_chapter162fromthenonhewouldneverbeabletorecover'
 import A2_CHAPTER163UNEXPECTEDREQUEST from '@/components/62_chapter163unexpectedrequest'
 import A3_CHAPTER164SOMETHINGTHATCOSTSMONEYBUTDOESNOTPLEASE from '@/components/63_chapter164somethingthatcostsmoneybutdoesnotplease'
 import A4_CHAPTER165ANAMAZINGSECRETBURIEDINCEMENT from '@/components/64_chapter165anamazingsecretburiedincement'
 import A5_CHAPTER166YOUMAYNOTBELIEVEIT from '@/components/65_chapter166youmaynotbelieveit'
 import A6_CHAPTER167TOTHINKTHATHEWOULDHAVESUCHABLACKSTOMACH from '@/components/66_chapter167tothinkthathewouldhavesuchablackstomach'
 import A7_CHAPTER168KUNLUNRUINS from '@/components/67_chapter168kunlunruins'
 import A8_CHAPTER169LIMITLESSAFTEREFFECTS from '@/components/68_chapter169limitlessaftereffects'
 import A9_CHAPTER170SNAKEHEAD from '@/components/69_chapter170snakehead'
 import A0_CHAPTER171DONTYOUDAREPLAYWITHME from '@/components/70_chapter171dontyoudareplaywithme'
 import A1_CHAPTER172SPATIALFISSUREFORMATION from '@/components/71_chapter172spatialfissureformation'
 import A2_CHAPTER173FANCY from '@/components/72_chapter173fancy'
 import A3_CHAPTER174PICKONEGAME from '@/components/73_chapter174pickonegame'
 import A4_CHAPTER175DEPRIVATIONOFPOWER from '@/components/74_chapter175deprivationofpower'
 import A5_CHAPTER176ONELOOKATSHENLANGSMISTAKEFORLIFE from '@/components/75_chapter176onelookatshenlangsmistakeforlife'
 import A6_CHAPTER177DISASTERSORSURPRISES from '@/components/76_chapter177disastersorsurprises'
 import A7_CHAPTER178INFERIORHUMANBEING from '@/components/77_chapter178inferiorhumanbeing'
 import A8_CHAPTER179IDIOT from '@/components/78_chapter179idiot'
 import A9_CHAPTER180WHATALUNATIC from '@/components/79_chapter180whatalunatic'
 import A0_CHAPTER181ONEAFTERANOTHERTHEYWERESHOCKED from '@/components/80_chapter181oneafteranothertheywereshocked'
 import A1_CHAPTER182THEWILLOFTHEANCESTORS from '@/components/81_chapter182thewilloftheancestors'
 import A2_CHAPTER183ALLUSED from '@/components/82_chapter183allused'
 import A3_CHAPTER184THEPRICEOFMOURNING from '@/components/83_chapter184thepriceofmourning'
 import A4_CHAPTER185ANNULMENT from '@/components/84_chapter185annulment'
 import A5_CHAPTER186WHOWOULDTAKEANANTSERIOUSLY from '@/components/85_chapter186whowouldtakeanantseriously'
 import A6_CHAPTER187THROWAFACEBOOK from '@/components/86_chapter187throwafacebook'
 import A7_CHAPTER188THEMORTALWORLDNEEDSTHESTRONG from '@/components/87_chapter188themortalworldneedsthestrong'
 import A8_CHAPTER189KUNLUNTOMB from '@/components/88_chapter189kunluntomb'
 import A9_CHAPTER190THEQUEENMOTHERSTRUEAPPEARANCE from '@/components/89_chapter190thequeenmotherstrueappearance'
 import A0_CHAPTER191JASPERJELLY from '@/components/90_chapter191jasperjelly'
 import A1_CHAPTER192MILLIONSOFYEARSOFRAREENCOUNTERS from '@/components/91_chapter192millionsofyearsofrareencounters'
 import A2_CHAPTER193DOYOUKNOWHOWTOUSETHEEIGHTEENSUBDUINGDRAGONPALMS from '@/components/92_chapter193doyouknowhowtousetheeighteensubduingdragonpalms'
 import A3_CHAPTER194THEJINFAMILYHASBROUGHTTHEBLAMEONTHEMSELVES from '@/components/93_chapter194thejinfamilyhasbroughttheblameonthemselves'
 import A4_CHAPTER195YOUARENOTQUALIFIED from '@/components/94_chapter195youarenotqualified'
 import A5_CHAPTER196HELLHOUND from '@/components/95_chapter196hellhound'
 import A6_CHAPTER197ONEDAYIWILLFINDYOU from '@/components/96_chapter197onedayiwillfindyou'
 import A7_CHAPTER198SOSSMS from '@/components/97_chapter198sossms'
 import A8_CHAPTER199YOURFRIENDISINOURHANDS from '@/components/98_chapter199yourfriendisinourhands'
 import A9_CHAPTER200YOUAREHERRAYOFSUNSHINE from '@/components/99_chapter200youareherrayofsunshine'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter101incurringdisastertotheupperbody",
 			"name" : "0_chapter101incurringdisastertotheupperbody",
 			"component" : A_CHAPTER101INCURRINGDISASTERTOTHEUPPERBODY
 		},
 		{
 			"path" : "/1_chapter102blameyourwife",
 			"name" : "1_chapter102blameyourwife",
 			"component" : A_CHAPTER102BLAMEYOURWIFE
 		},
 		{
 			"path" : "/2_chapter103shock",
 			"name" : "2_chapter103shock",
 			"component" : A_CHAPTER103SHOCK
 		},
 		{
 			"path" : "/3_chapter104ameanoldladyofthezhoufamily",
 			"name" : "3_chapter104ameanoldladyofthezhoufamily",
 			"component" : A_CHAPTER104AMEANOLDLADYOFTHEZHOUFAMILY
 		},
 		{
 			"path" : "/4_chapter105houseburn",
 			"name" : "4_chapter105houseburn",
 			"component" : A_CHAPTER105HOUSEBURN
 		},
 		{
 			"path" : "/5_chapter106sacrificesoninlawtopreservethefamily",
 			"name" : "5_chapter106sacrificesoninlawtopreservethefamily",
 			"component" : A_CHAPTER106SACRIFICESONINLAWTOPRESERVETHEFAMILY
 		},
 		{
 			"path" : "/6_chapter107divorcewhenyougetback",
 			"name" : "6_chapter107divorcewhenyougetback",
 			"component" : A_CHAPTER107DIVORCEWHENYOUGETBACK
 		},
 		{
 			"path" : "/7_chapter108lowthreelowfour",
 			"name" : "7_chapter108lowthreelowfour",
 			"component" : A_CHAPTER108LOWTHREELOWFOUR
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js